import { AddItemButton } from '@core/components/Buttons';
import FormTitle from '@core/components/FormTitle';
import { TextInput } from '@core/components/Inputs';
import { Divider, Grid, IconButton, InputBase, Tooltip, makeStyles } from '@material-ui/core';
import InputMonetario from 'app/components/Input/InputMonetario';
import SelectCategoria from 'app/components/Select/SelectCategoria';
import { confirmarAlert } from 'app/services/alerts';
import * as Actions from 'app/store/actions';
import { FieldArray } from 'formik';
import NP from 'number-precision';
import React, { Fragment, useEffect, useState } from 'react';
import { MdHighlightOff, MdSettings } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { ContasPagarUtil } from '../store/contasPagarAction';
import PopoverRateioContaPagar from './modal/PopoverRateioContaPagar';

/*
RNE-174 - Limite de inclusão de categoria na conta a pagar : Public <<Functional>> Feature
Created:	14/04/2020 14:49:28
Modified:	30/04/2020 10:17:12
Project:	
Advanced:	
O sistema deve permitir a inclusão de 5 categorias no total.
Quando chegar na quinta linha inserida, o sistema deve apagar o comando "Adicionar categoria".
*/
const exibirAdicionarCategorias = (categorias) => {
  return categorias && categorias.length <= 4;
};

const exibirDiferenca = (values) => {
  const valorDiferenca = ContasPagarUtil.calcularDiferencaCategorias(values);
  return (
    valorDiferenca !== 0 && (
      <Grid item xs={12} sm={12}>
        <InputBase
          inputProps={{ 'aria-label': 'naked' }}
          style={{ color: 'red' }}
          value={`Diferença ${new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
          }).format(valorDiferenca)}`}
        />
      </Grid>
    )
  );
};
const useStyles = makeStyles({
  divider: {
    backgroundColor: 'rgba(0, 0, 0, 0.50)',
    marginBottom: 16,
  },
  dividerTitle: {
    backgroundColor: '#707070',
    marginBottom: 8,
    opacity: '0.5',
  },
  title: {
    fontSize: 15,
    fontWeight: 500,
  },
  viewMore: {
    color: '#53c4e6',
    textTransform: 'capitalize',
    '&:hover, &:focus': {
      cursor: 'pointer',
    },
  },
});
const ContasPagarCategorias = ({
  values,
  handleChange,
  handleBlur,
  exibirCalculo = true,
  touched = [],
  errors = [],
  natureza = 'DESPESA',
  disabled,
  origemCompra,
  origemConciliacao,
  disabledDescricao,
}) => {
  const { categorias } = values;
  const styles = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElIndex, setAnchorElIndex] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const recalcularImpostosRetencao = () => {
      if (categorias?.length === 1 && categorias[0].valorBruto && values?.retencoes?.length > 0) {
        const baseCalculo = ContasPagarUtil.calcularValorTotalBruto(values);
        values.retencoes.forEach((retencao) => {
          const valorImposto = ContasPagarUtil.arredondaCasasDecimais(
            NP.times(baseCalculo, NP.divide(retencao?.imposto?.aliquota || 0, 100)),
            2
          );
          if (retencao.valor !== valorImposto) {
            retencao.valor = valorImposto;
          }
        });
      }
    };

    recalcularImpostosRetencao();
  }, [categorias, values]);

  const handleOpenPopover = (event, index) => {
    setAnchorElIndex(index);
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorElIndex(null);
    setAnchorEl(null);
  };

  const showSuccess = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'success' }));
  };

  return (
    <>
      <Grid container item spacing={3}>
        <Grid item xs={12}>
          <FormTitle title="Categorias" />
        </Grid>
      </Grid>

      <FieldArray name="categorias">
        {(arrayHelpers) => {
          const categoriasAdicionadas =
            categorias &&
            categorias.map((itemCategoria, index) => {
              const handleSubmit = (rateios) => {
                categorias[index] = Object.assign(
                  { ...categorias[index], rateios: categorias[index].rateios },
                  rateios
                );
                showSuccess('Rateio dos centros de custos efetuado com sucesso para a categoria.');
                handleClosePopover();
              };

              return (
                <Fragment key={index}>
                  <Grid container item spacing={3} alignItems="center">
                    <Grid item xs={6}>
                      <p className={styles.title}>{`Categoria ${index + 1}`}</p>
                    </Grid>
                  </Grid>
                  <Grid xs={12} item>
                    <Divider className={styles.dividerTitle} />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <SelectCategoria
                      id={`categorias[${index}].classe`}
                      required
                      label="Categoria"
                      value={itemCategoria.classe}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      maxLength={100}
                      natureza={natureza}
                      touched={errors[index]?.classe}
                      error={errors[index]?.classe}
                      disabled={disabled || origemCompra}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <InputMonetario
                      fullWidth
                      id={`categorias[${index}].valorBruto`}
                      label="Valor bruto(R$)"
                      onBlur={handleBlur}
                      value={itemCategoria?.valorBruto}
                      touched={errors[index]?.valorBruto}
                      error={errors[index]?.valorBruto}
                      helperText={errors[index]?.valorBruto}
                      handleChange={handleChange}
                      disabled={disabled || origemCompra}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                    <TextInput
                      id={`categorias[${index}].descricao`}
                      fullWidth
                      label="Descrição"
                      value={itemCategoria?.descricao}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      maxLength={50}
                      touched={touched[index]?.descricao}
                      error={errors[index]?.descricao}
                      disabled={disabledDescricao}
                    />
                  </Grid>
                  {/*
                  RNE-149 - Exibição do ícone de exclusão de registros adicionados : Public <<Functional>> Feature
                  Created:	03/04/2020 11:43:19
                  Modified:	03/04/2020 16:27:59
                  Project:	
                  Advanced:	
                  O sistema deve exibir o ícone para excluir categoria, retenção e parcela a partir do segundo registro. O ícone não deve ser exibido para o primeiro registro.
                  */}

                  {itemCategoria.classe && (
                    <Grid item style={{ justifyContent: 'center', alignItems: 'center' }}>
                      <Tooltip title="Rateio dos centros de custos" placement="right-end">
                        <IconButton onClick={(event) => handleOpenPopover(event, index)}>
                          <MdSettings size={18} />
                        </IconButton>
                      </Tooltip>

                      <PopoverRateioContaPagar
                        index={index}
                        anchorElIndex={anchorElIndex}
                        anchorEl={anchorEl}
                        onSubmit={handleSubmit}
                        onClose={handleClosePopover}
                        categoria={itemCategoria}
                        disabled={disabled}
                      />
                    </Grid>
                  )}
                  {index !== 0 && !disabled && !origemCompra && (
                    <Grid item xs={1} style={{ justifyContent: 'center', alignItems: 'center' }}>
                      <Tooltip title="Excluir categoria" placement="right-end">
                        <IconButton onClick={() => arrayHelpers.remove(index)}>
                          <MdHighlightOff size={18} />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  )}
                </Fragment>
              );
            });
          return (
            <>
              {categoriasAdicionadas}

              {exibirAdicionarCategorias(categorias) && !disabled && !origemCompra && (
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <AddItemButton
                    onClick={() => {
                      if (categorias.length === 1 && !origemConciliacao) {
                        confirmarAlert({
                          confirmar: () => {
                            handleChange({ target: { id: 'retencoes', value: undefined } });
                            arrayHelpers.push({});
                          },
                          titulo: 'Ao informar mais de uma categoria, não será possível informar retenção.',
                          mensagem: 'Deseja continuar?',
                        });
                      } else {
                        handleChange({ target: { id: 'retencoes', value: [{}] } });
                        arrayHelpers.push({});
                      }
                    }}
                  >
                    Adicionar categoria
                  </AddItemButton>
                </Grid>
              )}
            </>
          );
        }}
      </FieldArray>

      {exibirCalculo && exibirDiferenca(values)}
      <Grid xs={12} item spacing={3}>
        <Divider style={{ background: 'rgba(0,0,0,0.5)' }} />
      </Grid>
    </>
  );
};
export default ContasPagarCategorias;
